import { render } from "./SuccessIcon.vue?vue&type=template&id=1f06238e&scoped=true"
import script from "./SuccessIcon.vue?vue&type=script&lang=js"
export * from "./SuccessIcon.vue?vue&type=script&lang=js"

import "./SuccessIcon.vue?vue&type=style&index=0&id=1f06238e&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f06238e"]])

export default __exports__